<template>
  <div>
    <v-row dense>
      <v-col cols="10">
        <h2 class="b-indicator__collapse-title">1. Значение показателя</h2>
      </v-col>
    </v-row>
    <template v-if="rowOfValues.data.isdpo23 === '1'">
      <v-row dense>
        <v-col cols="10">
          <h3 class="b-indicator__collapse-subtitle">Исходные данные:</h3>
          <p>
            <span class="font-weight-bold mb-1">Форма 5.07. (фрагмент)</span><br>
            Численность обучающихся по программам бакалавриата, программам специалитета, программам магистратуры<br>
            по данным формы ВПО-1, человек
          </p>
        </v-col>
      </v-row>
      <doubleFragmentTable
          :item="item"
          :row-of-values="rowOfValues"
          :isdpo="rowOfValues.data.isdpo23"
          :columns="18"
          :form="'5.07'"
          :valueArrayForTable2="['nodao22', 'nodav22', 'nodaz22']"
          :arrayForTable2="['No', 'Nv', 'Nz']"
          :textUnderTable2="'сумма по формам обучения:'"
          :idKey="1"
      />
      <v-row dense>
        <v-col cols="10">
          <p>
            <span class="font-weight-bold mb-1">Форма 5.13. (фрагмент)</span><br>
            Численность обучающихся по программам ординатуры, программам ассистентуры-стажировки<br>
            по данным формы 1-НК, человек
          </p>
        </v-col>
      </v-row>
      <doubleFragmentTable
          :item="item"
          :row-of-values="rowOfValues"
          :isdpo="rowOfValues.data.isdpo23"
          :columns="18"
          :form="'5.13'"
          :valueArrayForTable2="['nodcs22']"
          :arrayForTable2="['NOA']"
          :textUnderTable2="'сумма по всем формам обучения:'"
          :idKey="2"
      />
      <v-row dense>
        <v-col cols="10">
          <p>
            <span class="font-weight-bold mb-1">Форма 5.19. (фрагмент)</span><br>
            Численность прошедших обучение по программам дополнительного профессионального образования<br>
            по данным формы 1-ПК, человек
          </p>
        </v-col>
      </v-row>
      <doubleFragmentTable
          :item="item"
          :row-of-values="rowOfValues"
          :isdpo="rowOfValues.data.isdpo23"
          :columns="17"
          :secondTableColumns="2"
          :form="'5.19'"
          :valueArrayForTable2="[]"
          :arrayForTable2="['КПо', 'ППо']"
          :idKey="3"
      />

      <!--      //////////////////////////////////////////////     -->

      <div class="d-flex flex-row mt-3">
        <div class="d-flex flex-column">
          <div class="formul-text">NP</div>
          <div class="formul-text">ПКП</div>
          <formulsFraction :need-bottom-line="false">
            ППП
          </formulsFraction>
        </div>
        <div class="d-flex flex-column mx-1">
          <div class="alternate-text">=</div>
          <div class="alternate-text">=</div>
          <formulsFraction :need-bottom-line="false">
            <div class="alternate-text">=</div>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column">
          <div class="formul-text text-center"><span class="alternate-text ">1,0 ×</span> No</div>
          <div class="formul-text text-center"><span class="alternate-text ">1,0 ×</span> КПo</div>
          <formulsFraction :need-bottom-line="true">
            <template><span class="alternate-text mr-1">1,0 ×</span>ППo</template>
            <template #bottom>очная <br>
              форма
            </template>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column mx-1">
          <div class="alternate-text">+</div>
          <div class="alternate-text">+</div>
          <formulsFraction :need-bottom-line="false">
            <div class="alternate-text">+</div>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column">
          <div class="formul-text text-center"><span class="alternate-text ">   0,25 ×</span> Nv</div>
          <div class="formul-text text-center"><span class="alternate-text ">   0,25 ×</span> КПv</div>
          <formulsFraction :need-bottom-line="true">
            <template><span class="alternate-text mr-1">   0,25 ×</span>ППv</template>
            <template #bottom>очно-заочная <br>
              форма
            </template>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column mx-1">
          <div class="alternate-text">+</div>
          <div class="alternate-text">+</div>
          <formulsFraction :need-bottom-line="false">
            <div class="alternate-text">+</div>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column">
          <div class="formul-text"><span class="alternate-text ">   0,1 ×</span> Nz</div>
          <div class="formul-text"><span class="alternate-text ">   0,1 ×</span> КПz</div>
          <formulsFraction :need-bottom-line="true">
            <template><span class="alternate-text mr-1">   0,1 ×</span>ППz</template>
            <template #bottom>заочная <br>
              форма
            </template>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column mx-1">
          <div class="alternate-text">=</div>
          <div class="alternate-text">=</div>
          <formulsFraction :need-bottom-line="false">
            <div class="alternate-text">=</div>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column">
          <div class="formul-text text-center"><span class="alternate-text ">1,0 ×</span>
            {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nodao22, 0, 'integer', true, 0) }}
          </div>
          <div class="formul-text text-center"><span class="alternate-text ">1,0 ×</span>
            {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nvpko22, 0, 'integer', true, 0) }}
            <!--            {{ $scripts.TableJs.checkValueWithNullAndReturnND(checkData('nvpko22'), 0, 'integer') }}-->
          </div>
          <formulsFraction :need-bottom-line="true">
            <template><span class="alternate-text mr-1">1,0 × </span>
              {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nvppo22, 0, 'integer', true, 0) }}
              <!--              {{ $scripts.TableJs.checkValueWithNullAndReturnND(checkData('nvppo22'), 0, 'integer') }}-->
            </template>
            <template #bottom>очная <br>
              форма
            </template>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column mx-1">
          <div class="alternate-text">+</div>
          <div class="alternate-text">+</div>
          <formulsFraction :need-bottom-line="false">
            <div class="alternate-text">+</div>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column">
          <div class="formul-text text-center"><span class="alternate-text ">   0,25 ×</span>
            {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nodav22, 0, 'integer', true, 0) }}
          </div>
          <div class="formul-text text-center"><span class="alternate-text ">   0,25 ×</span>
            {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nodav22, 0, 'integer', true, 0) }}
            <!--            {{ $scripts.TableJs.checkValueWithNullAndReturnND(checkData('nvpkv22'), 0, 'integer') }}-->
          </div>
          <formulsFraction :need-bottom-line="true">
            <template><span class="alternate-text mr-1">   0,25 ×</span>
              {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nvppv22, 0, 'integer', true, 0) }}
              <!--              {{ $scripts.TableJs.checkValueWithNullAndReturnND(checkData('nvppv22'), 0, 'integer') }}-->
            </template>
            <template #bottom>очно-заочная <br>
              форма
            </template>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column mx-1">
          <div class="alternate-text">+</div>
          <div class="alternate-text">+</div>
          <formulsFraction :need-bottom-line="false">
            <div class="alternate-text">+</div>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column">
          <div class="formul-text text-center"><span class="alternate-text ">   0,1 ×</span>
            {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nodaz22, 0, 'integer', true, 0) }}
          </div>
          <div class="formul-text text-center"><span class="alternate-text ">   0,1 ×</span>
            {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nvpkz22, 0, 'integer', true, 0) }}
            <!--            {{ $scripts.TableJs.checkValueWithNullAndReturnND(checkData('nvpkz22'), 0, 'integer') }}-->
          </div>
          <formulsFraction :need-bottom-line="true">
            <template><span class="alternate-text mr-1">   0,1 ×</span>
              {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nvppz22, 0, 'integer', true, 0) }}
              <!--              {{ $scripts.TableJs.checkValueWithNullAndReturnND(checkData('nvppz22'), 0, 'integer') }}-->
            </template>
            <template #bottom>заочная <br>
              форма
            </template>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column mx-1">
          <div class="alternate-text">=</div>
          <div class="alternate-text">=</div>
          <formulsFraction :need-bottom-line="false">
            <div class="alternate-text">=</div>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column">
          <div class="formul-text text-center">
            {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nodap22, 1, 'float', true, 0) }}
          </div>
          <div class="formul-text text-center">
            {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nvpkp22, 1, 'float', true, 0) }}
          </div>
          <formulsFraction class="mr-0" :need-bottom-line="true">
            <template> {{
                $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nvppp22, 1, 'float', true, 0)
              }}
            </template>
            <template #bottom>приведенный
              <br>
              контингент
            </template>
          </formulsFraction>
        </div>
      </div>
      <p>NP - приведенный контингент обучающихся по программам бакалавриата, специалитета и магистратуры</p>
      <p>ПКП - приведенный контингент обучившихся по программам повышения квалификации</p>
      <p>ППП - приведенный контингент обучившихся по программам профессиональной переподготовки</p>

      <h3 class="b-indicator__collapse-subtitle mt-5">Расчет значения показателя:</h3>
      <div class="d-flex flex-row align-center">
        <formulsFraction :need-bottom-line="true">
          <template>
            <div class="d-flex flex-row align-end">
              {{ item.title }}
              <div class="little-text ">0</div>
            </div>
          </template>
          <template #bottom>значение</template>
        </formulsFraction>
        <formulsFraction :need-bottom-line="false">
          <template>
            <span class="mt-8 alternate-text"> = </span>
          </template>
        </formulsFraction>
        <formulsFractionSimple>
          <template>
            <span class="alternate-text mx-1">0,25  × </span> ПКП <span class="alternate-text mx-1">+</span> ППП
          </template>
          <template #bottom>
            <span class="formul-text" style="  min-height: 49px">NP <span class="alternate-text ">+</span> NOA</span>
          </template>
        </formulsFractionSimple>
        <formulsFraction :need-bottom-line="false">
          <template>
            <span class="mt-8 alternate-text"> = </span>
          </template>
        </formulsFraction>
        <formulsFractionSimple>
          <template>
            <span class="alternate-text mx-1">0,25  × </span>
            {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nvpkp22, 1, 'float') }}
            <span class="alternate-text mx-1">+</span>
            {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nvppp22, 1, 'float') }}
          </template>
          <template #bottom>
            <span class="formul-text" style="  min-height: 49px">
              {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nodap22, 1, 'float') }}
              <span class="alternate-text ">+</span>
              {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nodcs22, 1, 'float') }}
            </span>
          </template>
        </formulsFractionSimple>
        <formulsFraction :need-bottom-line="false">
          <template>
            <span class="mt-8 alternate-text"> = </span>
          </template>
        </formulsFraction>
        <formulsFraction :need-bottom-line="false">
          <template>
            <span class="mt-8">{{
                $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data[item.dataFieldName + 'b022'], item.prd + 1, 'float')
              }}</span>
          </template>
        </formulsFraction>
      </div>
      <p class="mb-5">Если сумма значений показателей NP и NOA равна нулю, а сумма значений показателей ПКП и ППП больше
        нуля, значение принимается равным 1.</p>
    </template>

    <!--   ////////////////////////////////////// === 2 -->

    <template v-if="rowOfValues.data.isdpo23 === '2'">
      <v-row dense>
        <v-col cols="10">
          <h3 class="b-indicator__collapse-subtitle mb-1">Расчет параметров по разделам "G", "K", "N",
            поставленных в соответствие с УГСН 38.00.00</h3>
          <p>
            <span class="font-weight-bold mb-1">Форма 5.07. (фрагмент)</span><br>
            Численность обучающихся по программам бакалавриата, программам специалитета, программам магистратуры<br>
            по данным формы ВПО-1, человек
          </p>
        </v-col>
      </v-row>
      <doubleFragmentTable
          :item="item"
          :row-of-values="rowOfValues"
          :isdpo="rowOfValues.data.isdpo23"
          :columns="18"
          :form="'5.07'"
          :valueArrayForTable2="['nodeo22', 'nodev22', 'nodez22']"
          :arrayForTable2="['No1', 'Nv1', 'Nz1']"
          :textUnderTable2="'сумма по формам обучения:'"
          :idKey="4"
      />
      <p class="mb-3 d-flex">
        <span class="d-flex flex-row align-end mr-1">
          NOA<span class="little-text " style="line-height:12px;">1</span></span> = 0
        (по программам ординатуры и ассистентуры-стажировки нет УГСН 38.00.00)</p>
      <v-row dense>
        <v-col cols="10">
          <p>
            <span class="font-weight-bold mb-1">Форма 5.19. (фрагмент)</span><br>
            Численность прошедших обучение по программам дополнительного профессионального образования<br>
            по данным формы 1-ПК, человек
          </p>
        </v-col>
      </v-row>
      <doubleFragmentTable
          :item="item"
          :row-of-values="rowOfValues"
          :isdpo="rowOfValues.data.isdpo23"
          :columns="17"
          :secondTableColumns="2"
          :form="'5.19'"
          :valueArrayForTable2="[]"
          :arrayForTable2="['КПо1', 'ППо1']"
          :idKey="5"
      />
      <div class="d-flex flex-row  mt-3">
        <div class="d-flex flex-column">
          <div class="formul-text"><span class="d-flex flex-row align-end">NP
            <span class="little-text " style="line-height:12px;">1</span>
          </span>
          </div>
          <div class="formul-text"><span class="d-flex flex-row align-end">ПКП
            <span class="little-text" style="line-height:12px;">1</span>
          </span>
          </div>
          <formulsFraction :need-bottom-line="false">
            <span class="d-flex flex-row align-end">ППП<span class="little-text "
                                                             style="line-height:12px;">1</span></span>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column mx-1">
          <div class="alternate-text">=</div>
          <div class="alternate-text">=</div>
          <formulsFraction :need-bottom-line="false">
            <div class="alternate-text">=</div>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column">
          <div class="formul-text d-flex"><span class="alternate-text mr-1">1,0 ×</span> <span
              class="d-flex flex-row align-end">No<span class="little-text " style="line-height:12px;">1</span></span>
          </div>
          <div class="formul-text d-flex"><span class="alternate-text mr-1">1,0 ×</span> <span
              class="d-flex flex-row align-end">КПo<span class="little-text " style="line-height:12px;">1</span></span>
          </div>
          <formulsFraction :need-bottom-line="true">
            <template>
              <span class="alternate-text mr-1">1,0 ×</span>
              <span class="d-flex flex-row align-end">ППo<span class="little-text "
                                                               style="line-height:12px;">1</span></span>
            </template>
            <template #bottom>очная <br>
              форма
            </template>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column mx-1">
          <div class="alternate-text">+</div>
          <div class="alternate-text">+</div>
          <formulsFraction :need-bottom-line="false">
            <div class="alternate-text">+</div>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column">
          <div class="formul-text d-flex"><span class="alternate-text mr-1">   0,25 ×</span> <span
              class="d-flex flex-row align-end">Nv<span class="little-text " style="line-height:12px;">1</span></span>
          </div>
          <div class="formul-text d-flex"><span class="alternate-text mr-1">   0,25 ×</span> <span
              class="d-flex flex-row align-end">КПv<span class="little-text " style="line-height:12px;">1</span></span>
          </div>
          <formulsFraction :need-bottom-line="true">
            <template><span class="alternate-text mr-1">   0,25 ×</span><span class="d-flex flex-row align-end">ППv<span
                class="little-text " style="line-height:12px;">1</span></span></template>
            <template #bottom>очно-заочная <br>
              форма
            </template>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column mx-1">
          <div class="alternate-text">+</div>
          <div class="alternate-text">+</div>
          <formulsFraction :need-bottom-line="false">
            <div class="alternate-text">+</div>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column">
          <div class="formul-text d-flex"><span class="alternate-text mr-1">   0,1 ×</span> <span
              class="d-flex flex-row align-end">Nz<span class="little-text " style="line-height:12px;">1</span></span>
          </div>
          <div class="formul-text d-flex"><span class="alternate-text mr-1">   0,1 ×</span> <span
              class="d-flex flex-row align-end">КПz<span class="little-text " style="line-height:12px;">1</span></span>
          </div>
          <formulsFraction :need-bottom-line="true">
            <template><span class="alternate-text mr-1">   0,1 ×</span><span class="d-flex flex-row align-end">ППz<span
                class="little-text " style="line-height:12px;">1</span></span></template>
            <template #bottom>заочная <br>
              форма
            </template>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column mx-1">
          <div class="alternate-text">=</div>
          <div class="alternate-text">=</div>
          <formulsFraction :need-bottom-line="false">
            <div class="alternate-text">=</div>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column">
          <div class="formul-text"><span class="alternate-text mr-1">1,0 ×</span>{{
              $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nodeo22, 0, 'integer')
            }}
          </div>
          <div class="formul-text"><span class="alternate-text mr-1">1,0 ×</span>{{
              $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nveko22, 0, 'integer')
            }}
          </div>
          <formulsFraction :need-bottom-line="true">
            <template><span class="alternate-text mr-1">1,0 ×</span>{{
                $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nvepo22, 0, 'integer')
              }}
            </template>
            <template #bottom>очная <br>
              форма
            </template>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column mx-1">
          <div class="alternate-text">+</div>
          <div class="alternate-text">+</div>
          <formulsFraction :need-bottom-line="false">
            <div class="alternate-text">+</div>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column">
          <div class="formul-text"><span class="alternate-text mr-1">   0,25 ×</span>{{
              $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nodev22, 0, 'integer')
            }}
          </div>
          <div class="formul-text"><span class="alternate-text mr-1">   0,25 ×</span>{{
              $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nvekv22, 0, 'integer')
            }}
          </div>
          <formulsFraction :need-bottom-line="true">
            <template><span class="alternate-text mr-1">   0,25 ×</span>{{
                $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nvepv22, 0, 'integer')
              }}
            </template>
            <template #bottom>очно-заочная <br>
              форма
            </template>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column mx-1">
          <div class="alternate-text">+</div>
          <div class="alternate-text">+</div>
          <formulsFraction :need-bottom-line="false">
            <div class="alternate-text">+</div>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column">
          <div class="formul-text"><span class="alternate-text mr-1">   0,1 ×</span>{{
              $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nodez22, 0, 'integer')
            }}
          </div>
          <div class="formul-text"><span class="alternate-text mr-1">   0,1 ×</span>{{
              $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nvekz22, 0, 'integer')
            }}
          </div>
          <formulsFraction :need-bottom-line="true">
            <template><span class="alternate-text mr-1">   0,1 ×</span>
              {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nvepz22, 0, 'integer') }}
            </template>
            <template #bottom>заочная <br>
              форма
            </template>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column mx-1">
          <div class="alternate-text">=</div>
          <div class="alternate-text">=</div>
          <formulsFraction :need-bottom-line="false">
            <div class="alternate-text">=</div>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column">
          <div class="formul-text text-center">
            {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nodep22, 1, 'float') }}
          </div>
          <div class="formul-text text-center">
            {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nvekp22, 1, 'float') }}
          </div>
          <formulsFraction :need-bottom-line="true" class="mr-0">
            <template>{{
                $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nvepp22, 1, 'float')
              }}
            </template>
            <template #bottom>приведенный
              <br>
              контингент
            </template>
          </formulsFraction>
        </div>
      </div>
      <p class="d-flex flex-row"><span class="d-flex flex-row align-end">NP<span class="little-text "
                                                                                 style="line-height:12px;">1</span></span>
        - приведенный контингент обучающихся по программам бакалавриата, специалитета и магистратуры</p>
      <p class="d-flex flex-row"><span class="d-flex flex-row align-end">ПКП<span class="little-text "
                                                                                  style="line-height:12px;">1</span></span>
        - приведенный контингент обучившихся по программам повышения квалификации</p>
      <p class="d-flex flex-row mb-5"><span class="d-flex flex-row align-end">ППП<span class="little-text "
                                                                                       style="line-height:12px;">1</span></span>
        - приведенный контингент обучившихся по программам профессиональной переподготовки</p>
      <!--     //////////////////////////////////////////////////// -->
      <v-row dense>
        <v-col cols="10">
          <h3 class="b-indicator__collapse-subtitle mb-1">Расчет параметров по разделу "O" ОКВЭД:</h3>
          <p>
            <span class="font-weight-bold mb-1">Форма 5.07. (фрагмент)</span><br>
            Численность обучающихся по программам бакалавриата, программам специалитета, программам магистратуры<br>
            по данным формы ВПО-1, человек
          </p>
        </v-col>
      </v-row>
      <doubleFragmentTable
          :item="item"
          :row-of-values="rowOfValues"
          :isdpo="rowOfValues.data.isdpo23"
          :columns="18"
          :form="'5.07'"
          :valueArrayForTable2="['nodgo22', 'nodgv22', 'nodgz22']"
          :arrayForTable2="['No2', 'Nv2', 'Nz2']"
          :textUnderTable2="'сумма по формам обучения:'"
          :dopInfo="'okvedO'"
          :idKey="6"
      />
      <p class="mb-3 d-flex">
        <span class="d-flex flex-row align-end mr-1">
          NOA<span class="little-text " style="line-height:12px;">2</span></span> = 0
        (по программам ординатуры и ассистентуры-стажировки нет УГСН 38.00.00 и 40.00.00)</p>
      <v-row dense>
        <v-col cols="10">
          <p>
            <span class="font-weight-bold mb-1">Форма 5.19. (фрагмент)</span><br>
            Численность прошедших обучение по программам дополнительного профессионального образования<br>
            по данным формы 1-ПК, человек
          </p>
        </v-col>
      </v-row>
      <doubleFragmentTable
          :item="item"
          :row-of-values="rowOfValues"
          :isdpo="rowOfValues.data.isdpo23"
          :columns="17"
          :secondTableColumns="2"
          :form="'5.19'"
          :valueArrayForTable2="[]"
          :arrayForTable2="['КПо2', 'ППо2']"
          :dopInfo="'okvedO'"
          :idKey="7"
      />
      <div class="d-flex flex-row  mt-3">
        <div class="d-flex flex-column">
          <div class="formul-text"><span class="d-flex flex-row align-end">NP
            <span class="little-text " style="line-height:12px;">2</span>
          </span>
          </div>
          <div class="formul-text"><span class="d-flex flex-row align-end">ПКП
            <span class="little-text" style="line-height:12px;">2</span>
          </span>
          </div>
          <formulsFraction :need-bottom-line="false">
            <span class="d-flex flex-row align-end">ППП<span class="little-text "
                                                             style="line-height:12px;">2</span></span>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column mx-1">
          <div class="alternate-text">=</div>
          <div class="alternate-text">=</div>
          <formulsFraction :need-bottom-line="false">
            <div class="alternate-text">=</div>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column">
          <div class="formul-text d-flex"><span class="alternate-text mr-1">1,0 ×</span> <span
              class="d-flex flex-row align-end">No<span class="little-text " style="line-height:12px;">2</span></span>
          </div>
          <div class="formul-text d-flex"><span class="alternate-text mr-1">1,0 ×</span> <span
              class="d-flex flex-row align-end">КПo<span class="little-text " style="line-height:12px;">2</span></span>
          </div>
          <formulsFraction :need-bottom-line="true">
            <template>
              <span class="alternate-text mr-1">1,0 ×</span>
              <span class="d-flex flex-row align-end">ППo<span class="little-text "
                                                               style="line-height:12px;">2</span></span>
            </template>
            <template #bottom>очная <br>
              форма
            </template>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column mx-1">
          <div class="alternate-text">+</div>
          <div class="alternate-text">+</div>
          <formulsFraction :need-bottom-line="false">
            <div class="alternate-text">+</div>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column">
          <div class="formul-text d-flex"><span class="alternate-text mr-1">   0,25 ×</span> <span
              class="d-flex flex-row align-end">Nv<span class="little-text " style="line-height:12px;">2</span></span>
          </div>
          <div class="formul-text d-flex"><span class="alternate-text mr-1">   0,25 ×</span> <span
              class="d-flex flex-row align-end">КПv<span class="little-text " style="line-height:12px;">2</span></span>
          </div>
          <formulsFraction :need-bottom-line="true">
            <template><span class="alternate-text mr-1">   0,25 ×</span><span class="d-flex flex-row align-end">ППv<span
                class="little-text " style="line-height:12px;">2</span></span></template>
            <template #bottom>очно-заочная <br>
              форма
            </template>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column mx-1">
          <div class="alternate-text">+</div>
          <div class="alternate-text">+</div>
          <formulsFraction :need-bottom-line="false">
            <div class="alternate-text">+</div>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column">
          <div class="formul-text d-flex"><span class="alternate-text mr-1">   0,1 ×</span> <span
              class="d-flex flex-row align-end">Nz<span class="little-text " style="line-height:12px;">2</span></span>
          </div>
          <div class="formul-text d-flex"><span class="alternate-text mr-1">   0,1 ×</span> <span
              class="d-flex flex-row align-end">КПz<span class="little-text " style="line-height:12px;">2</span></span>
          </div>
          <formulsFraction :need-bottom-line="true">
            <template><span class="alternate-text mr-1">   0,1 ×</span><span class="d-flex flex-row align-end">ППz<span
                class="little-text " style="line-height:12px;">2</span></span></template>
            <template #bottom>заочная <br>
              форма
            </template>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column mx-1">
          <div class="alternate-text">=</div>
          <div class="alternate-text">=</div>
          <formulsFraction :need-bottom-line="false">
            <div class="alternate-text">=</div>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column">
          <div class="formul-text"><span class="alternate-text mr-1">1,0 ×</span>{{
              $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nodgo22, 0, 'integer', true, 0)
            }}
          </div>
          <div class="formul-text"><span class="alternate-text mr-1">1,0 ×</span>{{
              $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nvgko22, 0, 'integer', true, 0)
            }}
          </div>
          <formulsFraction :need-bottom-line="true">
            <template><span class="alternate-text mr-1">1,0 ×</span>{{
                $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nvgpo22, 0, 'integer', true, 0)
              }}
            </template>
            <template #bottom>очная <br>
              форма
            </template>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column mx-1">
          <div class="alternate-text">+</div>
          <div class="alternate-text">+</div>
          <formulsFraction :need-bottom-line="false">
            <div class="alternate-text">+</div>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column">
          <div class="formul-text"><span class="alternate-text mr-1">   0,25 ×</span>{{
              $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nodgv22, 0, 'integer', true, 0)
            }}
          </div>
          <div class="formul-text"><span class="alternate-text mr-1">   0,25 ×</span>{{
              $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nvgkv22, 0, 'integer', true, 0)
            }}
          </div>
          <formulsFraction :need-bottom-line="true">
            <template><span class="alternate-text mr-1">   0,25 ×</span>{{
                $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nvgpv22, 0, 'integer', true, 0)
              }}
            </template>
            <template #bottom>очно-заочная <br>
              форма
            </template>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column mx-1">
          <div class="alternate-text">+</div>
          <div class="alternate-text">+</div>
          <formulsFraction :need-bottom-line="false">
            <div class="alternate-text">+</div>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column">
          <div class="formul-text"><span class="alternate-text mr-1">   0,1 ×</span>{{
              $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nodgz22, 0, 'integer', true, 0)
            }}
          </div>
          <div class="formul-text"><span class="alternate-text mr-1">   0,1 ×</span>{{
              $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nvgkz22, 0, 'integer', true, 0)
            }}
          </div>
          <formulsFraction :need-bottom-line="true">
            <template><span class="alternate-text mr-1">   0,1 ×</span>
              {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nvgpz22, 0, 'integer', true, 0) }}
            </template>
            <template #bottom>заочная <br>
              форма
            </template>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column mx-1">
          <div class="alternate-text">=</div>
          <div class="alternate-text">=</div>
          <formulsFraction :need-bottom-line="false">
            <div class="alternate-text">=</div>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column">
          <div class="formul-text text-center">
            {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nodgp22, 1, 'float', true, 0) }}
          </div>
          <div class="formul-text text-center">
            {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nvgkp22, 1, 'float', true, 0) }}
          </div>
          <formulsFraction :need-bottom-line="true" class="mr-0">
            <template>
              {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nvgpp22, 1, 'float', true, 0) }}
            </template>
            <template #bottom>приведенный
              <br>
              контингент
            </template>
          </formulsFraction>
        </div>
      </div>
      <p class="d-flex flex-row"><span class="d-flex flex-row align-end">NP<span class="little-text "
                                                                                 style="line-height:12px;">2</span></span>
        - приведенный контингент обучающихся по программам бакалавриата, специалитета и магистратуры</p>
      <p class="d-flex flex-row"><span class="d-flex flex-row align-end">ПКП<span class="little-text "
                                                                                  style="line-height:12px;">2</span></span>
        - приведенный контингент обучившихся по программам повышения квалификации</p>
      <p class="d-flex flex-row mb-5"><span class="d-flex flex-row align-end">ППП<span class="little-text "
                                                                                       style="line-height:12px;">2</span></span>
        - приведенный контингент обучившихся по программам профессиональной переподготовки</p>
      <!--    ////////////////////////////////  -->
      <v-row dense>
        <v-col cols="10">
          <h3 class="b-indicator__collapse-subtitle mb-1">Расчет параметров по разделу "M" ОКВЭД:</h3>
          <p>
            <span class="font-weight-bold mb-1">Форма 5.07. (фрагмент)</span><br>
            Численность обучающихся по программам бакалавриата, программам специалитета, программам магистратуры<br>
            по данным формы ВПО-1, человек
          </p>
        </v-col>
      </v-row>

      <doubleFragmentTable
          :item="item"
          :row-of-values="rowOfValues"
          :isdpo="rowOfValues.data.isdpo23"
          :columns="18"
          :form="'5.07'"
          :valueArrayForTable2="['nodao22', 'nodav22', 'nodaz22']"
          :arrayForTable2="['No3', 'Nv3', 'Nz3']"
          :textUnderTable2="'сумма по формам обучения:'"
          :dopInfo="'okvedM'"
          :idKey="8"
      />

      <v-row dense>
        <v-col cols="10">
          <p>
            <span class="font-weight-bold mb-1">Форма 5.13. (фрагмент)</span><br>
            Численность обучающихся по программам ординатуры, программам ассистентуры-стажировки<br>
            по данным формы 1-НК, человек
          </p>
        </v-col>
      </v-row>

      <doubleFragmentTable
          :item="item"
          :row-of-values="rowOfValues"
          :isdpo="rowOfValues.data.isdpo23"
          :columns="18"
          :form="'5.13'"
          :valueArrayForTable2="['nodcs22']"
          :arrayForTable2="['NOA2']"
          :textUnderTable2="'сумма по всем формам обучения:'"
          :dopInfo="'okvedM'"
          :idKey="9"
      />

      <v-row dense>
        <v-col cols="10">
          <p>
            <span class="font-weight-bold mb-1">Форма 5.19. (фрагмент)</span><br>
            Численность прошедших обучение по программам дополнительного профессионального образования<br>
            по данным формы 1-ПК, человек
          </p>
        </v-col>
      </v-row>

      <doubleFragmentTable
          :item="item"
          :row-of-values="rowOfValues"
          :isdpo="rowOfValues.data.isdpo23"
          :columns="17"
          :secondTableColumns="2"
          :form="'5.19'"
          :valueArrayForTable2="[]"
          :arrayForTable2="['КПо3', 'ППо3']"
          :dopInfo="'okvedM'"
          :idKey="10"
      />

      <div class="d-flex flex-row mt-3">
        <div class="d-flex flex-column">
          <div class="formul-text"><span class="d-flex flex-row align-end">NP<span class="little-text "
                                                                                   style="line-height:12px;">3</span></span>
          </div>
          <div class="formul-text"><span class="d-flex flex-row align-end">ПКП<span class="little-text "
                                                                                    style="line-height:12px;">3</span></span>
          </div>
          <formulsFraction :need-bottom-line="false">
            <span class="d-flex flex-row align-end">ППП<span class="little-text "
                                                             style="line-height:12px;">3</span></span>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column mx-1">
          <div class="alternate-text">=</div>
          <div class="alternate-text">=</div>
          <formulsFraction :need-bottom-line="false">
            <div class="alternate-text">=</div>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column">
          <div class="formul-text d-flex"><span class="alternate-text mr-1">1,0 ×</span> <span
              class="d-flex flex-row align-end">No<span class="little-text " style="line-height:12px;">3</span></span>
          </div>
          <div class="formul-text d-flex"><span class="alternate-text mr-1">1,0 ×</span> <span
              class="d-flex flex-row align-end">КПo<span class="little-text " style="line-height:12px;">3</span></span>
          </div>
          <formulsFraction :need-bottom-line="true">
            <template>
              <span class="alternate-text mr-1">1,0 ×</span>
              <span class="d-flex flex-row align-end">ППo<span class="little-text "
                                                               style="line-height:12px;">3</span></span>
            </template>
            <template #bottom>очная <br>
              форма
            </template>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column mx-1">
          <div class="alternate-text">+</div>
          <div class="alternate-text">+</div>
          <formulsFraction :need-bottom-line="false">
            <div class="alternate-text">+</div>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column">
          <div class="formul-text d-flex"><span class="alternate-text mr-1">   0,25 ×</span> <span
              class="d-flex flex-row align-end">Nv<span class="little-text " style="line-height:12px;">3</span></span>
          </div>
          <div class="formul-text d-flex"><span class="alternate-text mr-1">   0,25 ×</span> <span
              class="d-flex flex-row align-end">КПv<span class="little-text " style="line-height:12px;">3</span></span>
          </div>
          <formulsFraction :need-bottom-line="true">
            <template><span class="alternate-text mr-1">   0,25 ×</span><span class="d-flex flex-row align-end">ППv<span
                class="little-text " style="line-height:12px;">3</span></span></template>
            <template #bottom>очно-заочная <br>
              форма
            </template>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column mx-1">
          <div class="alternate-text">+</div>
          <div class="alternate-text">+</div>
          <formulsFraction :need-bottom-line="false">
            <div class="alternate-text">+</div>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column">
          <div class="formul-text d-flex"><span class="alternate-text mr-1">   0,1 ×</span> <span
              class="d-flex flex-row align-end">Nz<span class="little-text " style="line-height:12px;">3</span></span>
          </div>
          <div class="formul-text d-flex"><span class="alternate-text mr-1">   0,1 ×</span> <span
              class="d-flex flex-row align-end">КПz<span class="little-text " style="line-height:12px;">3</span></span>
          </div>
          <formulsFraction :need-bottom-line="true">
            <template><span class="alternate-text mr-1">   0,1 ×</span><span class="d-flex flex-row align-end">ППz<span
                class="little-text " style="line-height:12px;">3</span></span></template>
            <template #bottom>заочная <br>
              форма
            </template>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column mx-1">
          <div class="alternate-text">=</div>
          <div class="alternate-text">=</div>
          <formulsFraction :need-bottom-line="false">
            <div class="alternate-text">=</div>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column">
          <div class="formul-text"><span class="alternate-text ">1,0 ×</span>
            {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nodao22, 0, 'integer', true, 0) }}
          </div>
          <div class="formul-text"><span class="alternate-text ">1,0 ×</span>
            {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nvpko22, 0, 'integer', true, 0) }}
          </div>
          <formulsFraction :need-bottom-line="true">
            <template><span class="alternate-text mr-1">1,0 ×</span>{{
                $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nvppo22, 0, 'integer', true, 0)
              }}
            </template>
            <template #bottom>очная <br>
              форма
            </template>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column mx-1">
          <div class="alternate-text">+</div>
          <div class="alternate-text">+</div>
          <formulsFraction :need-bottom-line="false">
            <div class="alternate-text">+</div>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column">
          <div class="formul-text"><span class="alternate-text ">   0,25 ×</span>
            {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nodav22, 0, 'integer', true, 0) }}
          </div>
          <div class="formul-text"><span class="alternate-text ">   0,25 ×</span>
            {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nvpkv22, 0, 'integer', true, 0) }}
          </div>
          <formulsFraction :need-bottom-line="true">
            <template><span class="alternate-text mr-1">   0,25 ×</span>{{
                $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nvppv22, 0, 'integer', true, 0)
              }}
            </template>
            <template #bottom>очно-заочная <br>
              форма
            </template>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column mx-1">
          <div class="alternate-text">+</div>
          <div class="alternate-text">+</div>
          <formulsFraction :need-bottom-line="false">
            <div class="alternate-text">+</div>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column">
          <div class="formul-text"><span class="alternate-text ">   0,1 ×</span>
            {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nodaz22, 0, 'integer', true, 0) }}
          </div>
          <div class="formul-text"><span class="alternate-text ">   0,1 ×</span>
            {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nvpkz22, 0, 'integer', true, 0) }}
          </div>
          <formulsFraction :need-bottom-line="true">
            <template><span class="alternate-text mr-1">   0,1 ×</span>
              {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nvppz22, 0, 'integer', true, 0) }}
            </template>
            <template #bottom>заочная <br>
              форма
            </template>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column mx-1">
          <div class="alternate-text">=</div>
          <div class="alternate-text">=</div>
          <formulsFraction :need-bottom-line="false">
            <div class="alternate-text">=</div>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column">
          <div class="formul-text text-center">
            {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nodap22, 1, 'float', true, 0) }}
          </div>
          <div class="formul-text text-center">
            {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nvpkp22, 1, 'float', true, 0) }}
          </div>
          <formulsFraction :need-bottom-line="true">
            <template>
              {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nvppp22, 1, 'float', true, 0) }}
            </template>
            <template #bottom>приведенный<br>контингент</template>
          </formulsFraction>
        </div>
      </div>
      <p class="d-flex flex-row"><span class="d-flex flex-row align-end">NP<span class="little-text "
                                                                                 style="line-height:12px;">3</span></span>
        - приведенный контингент обучающихся по программам бакалавриата, специалитета и магистратуры</p>
      <p class="d-flex flex-row"><span class="d-flex flex-row align-end">ПКП<span class="little-text "
                                                                                  style="line-height:12px;">3</span></span>
        - приведенный контингент обучившихся по программам повышения квалификации</p>
      <p class="d-flex flex-row mb-5"><span class="d-flex flex-row align-end">ППП<span class="little-text "
                                                                                       style="line-height:12px;">3</span></span>
        - приведенный контингент обучившихся по программам профессиональной переподготовки</p>
      <div class="d-flex flex-row align-center">
        <formulsFraction :need-bottom-line="true">
          <template>
            <div class="d-flex flex-row align-end">
              {{ item.title }}
              <div class="little-text ">0</div>
            </div>
          </template>
          <template #bottom>значение</template>
        </formulsFraction>
        <formulsFraction :need-bottom-line="false">
          <template>
            <span class="mt-8 alternate-text"> = </span>
          </template>
        </formulsFraction>
        <formulsFractionSimple>
          <template>
            <span class="alternate-text mx-1">0,25  × </span> <span class="d-flex flex-row align-end">ПКП<span
              class="little-text " style="line-height:12px;">1</span></span> <span class="alternate-text mx-1">+</span>
            <span class="d-flex flex-row align-end">
              ППП<span class="little-text" style="line-height:12px;">1</span>
            </span>
          </template>
          <template #bottom>
            <div class="formul-text d-flex align-start" style="  min-height: 49px"><span
                class="d-flex flex-row align-end">NP<span class="little-text " style="line-height:12px;">1</span></span>
              <span class="mx-1 d-flex alternate-text">+</span> <span class="d-flex flex-row align-end">NOA<span
                  class="little-text " style="line-height:12px;">1</span></span></div>
          </template>
        </formulsFractionSimple>
        <formulsFraction :need-bottom-line="false">
          <template>
            <span class="mt-8 alternate-text"> + </span>
          </template>
        </formulsFraction>
        <formulsFractionSimple>
          <template>
            <span class="alternate-text mx-1">0,25  × </span> <span class="d-flex flex-row align-end">ПКП<span
              class="little-text " style="line-height:12px;">2</span></span> <span class="alternate-text mx-1">+</span>
            <span class="d-flex flex-row align-end">
              ППП<span class="little-text" style="line-height:12px;">2</span>
            </span>
          </template>
          <template #bottom>
            <div class="formul-text d-flex align-start" style="  min-height: 49px"><span
                class="d-flex flex-row align-end">NP<span class="little-text " style="line-height:12px;">2</span></span>
              <span class="mx-1 d-flex alternate-text">+</span> <span class="d-flex flex-row align-end">NOA<span
                  class="little-text " style="line-height:12px;">2</span></span></div>
          </template>
        </formulsFractionSimple>
        <formulsFraction :need-bottom-line="false">
          <template>
            <span class="mt-8 alternate-text"> + </span>
          </template>
        </formulsFraction>
        <formulsFractionSimple>
          <template>
            <span class="alternate-text mx-1">0,25  × </span> <span class="d-flex flex-row align-end">ПКП<span
              class="little-text " style="line-height:12px;">3</span></span> <span class="alternate-text mx-1">+</span>
            <span class="d-flex flex-row align-end">ППП<span class="little-text "
                                                             style="line-height:12px;">3</span></span>
          </template>
          <template #bottom>
            <div class="formul-text d-flex align-start" style="  min-height: 49px"><span
                class="d-flex flex-row align-end">NP<span class="little-text " style="line-height:12px;">3</span></span>
              <span class="mx-1 d-flex alternate-text">+</span> <span class="d-flex flex-row align-end">NOA<span
                  class="little-text " style="line-height:12px;">3</span></span></div>
          </template>
        </formulsFractionSimple>
        <formulsFraction :need-bottom-line="false">
          <template>
            <span class="mt-8 alternate-text"> = </span>
          </template>
        </formulsFraction>
        <formulsFractionSimple>
          <template>
            <span class="alternate-text mx-1">0,25  × </span>
            {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nvekp22, 1, 'float', true, 0) }} <span
              class="alternate-text mx-1">+</span>
            {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nvepp22, 1, 'float', true, 0) }}
          </template>
          <template #bottom>
            <span class="formul-text" style="  min-height: 49px"> {{
                $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nodep22, 1, 'float', true, 0)
              }} <span class="alternate-text mx-1">+</span> 0</span>
          </template>
        </formulsFractionSimple>
        <formulsFraction :need-bottom-line="false">
          <template>
            <span class="mt-8 alternate-text"> + </span>
          </template>
        </formulsFraction>
        <formulsFractionSimple>
          <template>
            <span class="alternate-text mx-1">0,25  × </span>
            {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nvgkp22, 1, 'float', true, 0) }} <span
              class="alternate-text mx-1">+</span>
            {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nvgpp22, 1, 'float', true, 0) }}
          </template>
          <template #bottom>
            <span class="formul-text" style="  min-height: 49px"> {{
                $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nodgp22, 1, 'float', true, 0)
              }} <span class="alternate-text mx-1">+</span> 0</span>
          </template>
        </formulsFractionSimple>
        <formulsFraction :need-bottom-line="false">
          <template>
            <span class="mt-8 alternate-text"> + </span>
          </template>
        </formulsFraction>
        <formulsFractionSimple>
          <template>
            <span class="alternate-text mx-1">0,25  × </span>
            {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nvpkp22, 1, 'float', true, 0) }} <span
              class="alternate-text mx-1">+</span>
            {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nvppp22, 1, 'float', true, 0) }}
          </template>
          <template #bottom>
            <span class="formul-text" style="  min-height: 49px"> {{
                $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nodap22, 1, 'float', true, 0)
              }} <span class="alternate-text mx-1">+</span> {{
                $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nodcs22, 1, 'float', true, 0)
              }}</span>
          </template>
        </formulsFractionSimple>
        <formulsFraction :need-bottom-line="false">
          <template>
            <span class="mt-8 alternate-text"> = </span>
          </template>
        </formulsFraction>
        <formulsFraction :need-bottom-line="false">
          <template>
            <span class="mt-8">{{
                $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data[item.dataFieldName + 'b022'], item.prd + 1, 'float', true, 0)
              }}</span>
          </template>
        </formulsFraction>
      </div>
      <p class="mb-3">Если хотя бы для одного вида экономической деятельности сумма значений показателей NP и NOA равна
        нулю, а сумма значений показателей ПКП и ППП больше нуля, значение принимается равным 1.</p>
    </template>


    <template v-if="rowOfValues.data.isdpo23 === '3'">
      <v-row dense>
        <v-col cols="10">
          <h3 class="b-indicator__collapse-subtitle mb-1">Расчет параметров по разделу "O" ОКВЭД:</h3>
          <p>
            <span class="font-weight-bold mb-1">Форма 5.07. (фрагмент)</span><br>
            Численность обучающихся по программам бакалавриата, программам специалитета, программам магистратуры<br>
            по данным формы ВПО-1, человек
          </p>
        </v-col>
      </v-row>
      <doubleFragmentTable
          :item="item"
          :row-of-values="rowOfValues"
          :isdpo="rowOfValues.data.isdpo23"
          :columns="18"
          :form="'5.07'"
          :valueArrayForTable2="['nodgo22', 'nodgv22', 'nodgz22']"
          :arrayForTable2="['No2', 'Nv2', 'Nz2']"
          :textUnderTable2="'сумма по формам обучения:'"
          :dopInfo="'okvedO'"
          :idKey="11"
      />
      <p class="mb-3 d-flex">
        <span class="d-flex flex-row align-end mr-1">
          NOA<span class="little-text " style="line-height:12px;">2</span></span> = 0
        (по программам ординатуры и ассистентуры-стажировки нет УГСН 38.00.00 и 40.00.00)</p>
      <v-row dense>
        <v-col cols="10">
          <p>
            <span class="font-weight-bold mb-1">Форма 5.19. (фрагмент)</span><br>
            Численность прошедших обучение по программам дополнительного профессионального образования<br>
            по данным формы 1-ПК, человек
          </p>
        </v-col>
      </v-row>
      <doubleFragmentTable
          :item="item"
          :row-of-values="rowOfValues"
          :isdpo="rowOfValues.data.isdpo23"
          :columns="17"
          :secondTableColumns="2"
          :form="'5.19'"
          :valueArrayForTable2="[]"
          :arrayForTable2="['КПо2', 'ППо2']"
          :dopInfo="'okvedO'"
          :idKey="12"
      />
      <div class="d-flex flex-row  mt-3">
        <div class="d-flex flex-column">
          <div class="formul-text"><span class="d-flex flex-row align-end">NP
            <span class="little-text " style="line-height:12px;">2</span>
          </span>
          </div>
          <div class="formul-text"><span class="d-flex flex-row align-end">ПКП
            <span class="little-text" style="line-height:12px;">2</span>
          </span>
          </div>
          <formulsFraction :need-bottom-line="false">
            <span class="d-flex flex-row align-end">ППП<span class="little-text "
                                                             style="line-height:12px;">2</span></span>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column mx-1">
          <div class="alternate-text">=</div>
          <div class="alternate-text">=</div>
          <formulsFraction :need-bottom-line="false">
            <div class="alternate-text">=</div>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column">
          <div class="formul-text d-flex"><span class="alternate-text mr-1">1,0 ×</span> <span
              class="d-flex flex-row align-end">No<span class="little-text " style="line-height:12px;">2</span></span>
          </div>
          <div class="formul-text d-flex"><span class="alternate-text mr-1">1,0 ×</span> <span
              class="d-flex flex-row align-end">КПo<span class="little-text " style="line-height:12px;">2</span></span>
          </div>
          <formulsFraction :need-bottom-line="true">
            <template>
              <span class="alternate-text mr-1">1,0 ×</span>
              <span class="d-flex flex-row align-end">ППo<span class="little-text "
                                                               style="line-height:12px;">2</span></span>
            </template>
            <template #bottom>очная <br>
              форма
            </template>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column mx-1">
          <div class="alternate-text">+</div>
          <div class="alternate-text">+</div>
          <formulsFraction :need-bottom-line="false">
            <div class="alternate-text">+</div>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column">
          <div class="formul-text d-flex"><span class="alternate-text mr-1">   0,25 ×</span> <span
              class="d-flex flex-row align-end">Nv<span class="little-text " style="line-height:12px;">2</span></span>
          </div>
          <div class="formul-text d-flex"><span class="alternate-text mr-1">   0,25 ×</span> <span
              class="d-flex flex-row align-end">КПv<span class="little-text " style="line-height:12px;">2</span></span>
          </div>
          <formulsFraction :need-bottom-line="true">
            <template><span class="alternate-text mr-1">   0,25 ×</span><span class="d-flex flex-row align-end">ППv<span
                class="little-text " style="line-height:12px;">2</span></span></template>
            <template #bottom>очно-заочная <br>
              форма
            </template>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column mx-1">
          <div class="alternate-text">+</div>
          <div class="alternate-text">+</div>
          <formulsFraction :need-bottom-line="false">
            <div class="alternate-text">+</div>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column">
          <div class="formul-text d-flex"><span class="alternate-text mr-1">   0,1 ×</span> <span
              class="d-flex flex-row align-end">Nz<span class="little-text " style="line-height:12px;">2</span></span>
          </div>
          <div class="formul-text d-flex"><span class="alternate-text mr-1">   0,1 ×</span> <span
              class="d-flex flex-row align-end">КПz<span class="little-text " style="line-height:12px;">2</span></span>
          </div>
          <formulsFraction :need-bottom-line="true">
            <template><span class="alternate-text mr-1">   0,1 ×</span><span class="d-flex flex-row align-end">ППz<span
                class="little-text " style="line-height:12px;">2</span></span></template>
            <template #bottom>заочная <br>
              форма
            </template>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column mx-1">
          <div class="alternate-text">=</div>
          <div class="alternate-text">=</div>
          <formulsFraction :need-bottom-line="false">
            <div class="alternate-text">=</div>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column">
          <div class="formul-text"><span class="alternate-text mr-1">1,0 ×</span>{{
              $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nodgo22, 0, 'integer', true, 0)
            }}
          </div>
          <div class="formul-text"><span class="alternate-text mr-1">1,0 ×</span>{{
              $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nvgko22, 0, 'integer', true, 0)
            }}
          </div>
          <formulsFraction :need-bottom-line="true">
            <template><span class="alternate-text mr-1">1,0 ×</span>{{
                $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nvgpo22, 0, 'integer', true, 0)
              }}
            </template>
            <template #bottom>очная <br>
              форма
            </template>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column mx-1">
          <div class="alternate-text">+</div>
          <div class="alternate-text">+</div>
          <formulsFraction :need-bottom-line="false">
            <div class="alternate-text">+</div>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column">
          <div class="formul-text"><span class="alternate-text mr-1">   0,25 ×</span>{{
              $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nodgv22, 0, 'integer', true, 0)
            }}
          </div>
          <div class="formul-text"><span class="alternate-text mr-1">   0,25 ×</span>{{
              $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nvgkv22, 0, 'integer', true, 0)
            }}
          </div>
          <formulsFraction :need-bottom-line="true">
            <template><span class="alternate-text mr-1">   0,25 ×</span>{{
                $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nvgpv22, 0, 'integer', true, 0)
              }}
            </template>
            <template #bottom>очно-заочная <br>
              форма
            </template>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column mx-1">
          <div class="alternate-text">+</div>
          <div class="alternate-text">+</div>
          <formulsFraction :need-bottom-line="false">
            <div class="alternate-text">+</div>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column">
          <div class="formul-text"><span class="alternate-text mr-1">   0,1 ×</span>{{
              $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nodgz22, 0, 'integer', true, 0)
            }}
          </div>
          <div class="formul-text"><span class="alternate-text mr-1">   0,1 ×</span>{{
              $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nvgkz22, 0, 'integer', true, 0)
            }}
          </div>
          <formulsFraction :need-bottom-line="true">
            <template><span class="alternate-text mr-1">   0,1 ×</span>
              {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nvgpz22, 0, 'integer', true, 0) }}
            </template>
            <template #bottom>заочная <br>
              форма
            </template>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column mx-1">
          <div class="alternate-text">=</div>
          <div class="alternate-text">=</div>
          <formulsFraction :need-bottom-line="false">
            <div class="alternate-text">=</div>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column">
          <div class="formul-text text-center">
            {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nodgp22, 1, 'float', true, 0) }}
          </div>
          <div class="formul-text text-center">
            {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nvgkp22, 1, 'float', true, 0) }}
          </div>
          <formulsFraction :need-bottom-line="true" class="mr-0">
            <template>
              {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nvgpp22, 1, 'float', true, 0) }}
            </template>
            <template #bottom>приведенный
              <br>
              контингент
            </template>
          </formulsFraction>
        </div>
      </div>
      <p class="d-flex flex-row"><span class="d-flex flex-row align-end">NP<span class="little-text "
                                                                                 style="line-height:12px;">2</span></span>
        - приведенный контингент обучающихся по программам бакалавриата, специалитета и магистратуры</p>
      <p class="d-flex flex-row"><span class="d-flex flex-row align-end">ПКП<span class="little-text "
                                                                                  style="line-height:12px;">2</span></span>
        - приведенный контингент обучившихся по программам повышения квалификации</p>
      <p class="d-flex flex-row mb-5"><span class="d-flex flex-row align-end">ППП<span class="little-text "
                                                                                       style="line-height:12px;">2</span></span>
        - приведенный контингент обучившихся по программам профессиональной переподготовки</p>
      <!--    ////////////////////////////////  -->
      <v-row dense>
        <v-col cols="10">
          <h3 class="b-indicator__collapse-subtitle mb-1">Расчет параметров по разделу "M" ОКВЭД:</h3>
          <p>
            <span class="font-weight-bold mb-1">Форма 5.07. (фрагмент)</span><br>
            Численность обучающихся по программам бакалавриата, программам специалитета, программам магистратуры<br>
            по данным формы ВПО-1, человек
          </p>
        </v-col>
      </v-row>

      <doubleFragmentTable
          :item="item"
          :row-of-values="rowOfValues"
          :isdpo="rowOfValues.data.isdpo23"
          :columns="18"
          :form="'5.07'"
          :valueArrayForTable2="['nodao22', 'nodav22', 'nodaz22']"
          :arrayForTable2="['No2', 'Nv2', 'Nz2']"
          :textUnderTable2="'сумма по формам обучения:'"
          :dopInfo="'okvedM'"
          :idKey="13"
      />

      <v-row dense>
        <v-col cols="10">
          <p>
            <span class="font-weight-bold mb-1">Форма 5.13. (фрагмент)</span><br>
            Численность обучающихся по программам ординатуры, программам ассистентуры-стажировки<br>
            по данным формы 1-НК, человек
          </p>
        </v-col>
      </v-row>

      <doubleFragmentTable
          :item="item"
          :row-of-values="rowOfValues"
          :isdpo="rowOfValues.data.isdpo23"
          :columns="18"
          :form="'5.13'"
          :valueArrayForTable2="['nodcs22']"
          :arrayForTable2="['NOA2']"
          :textUnderTable2="'сумма по всем формам обучения:'"
          :dopInfo="'okvedM'"
          :idKey="14"
      />

      <v-row dense>
        <v-col cols="10">
          <p>
            <span class="font-weight-bold mb-1">Форма 5.19. (фрагмент)</span><br>
            Численность прошедших обучение по программам дополнительного профессионального образования<br>
            по данным формы 1-ПК, человек
          </p>
        </v-col>
      </v-row>

      <doubleFragmentTable
          :item="item"
          :row-of-values="rowOfValues"
          :isdpo="rowOfValues.data.isdpo23"
          :columns="17"
          :secondTableColumns="2"
          :form="'5.19'"
          :valueArrayForTable2="[]"
          :arrayForTable2="['КПо2', 'ППо2']"
          :dopInfo="'okvedM'"
          :idKey="15"
      />

      <div class="d-flex flex-row mt-3">
        <div class="d-flex flex-column">
          <div class="formul-text"><span class="d-flex flex-row align-end">NP<span class="little-text "
                                                                                   style="line-height:12px;">3</span></span>
          </div>
          <div class="formul-text"><span class="d-flex flex-row align-end">ПКП<span class="little-text "
                                                                                    style="line-height:12px;">3</span></span>
          </div>
          <formulsFraction :need-bottom-line="false">
            <span class="d-flex flex-row align-end">ППП<span class="little-text "
                                                             style="line-height:12px;">3</span></span>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column mx-1">
          <div class="alternate-text">=</div>
          <div class="alternate-text">=</div>
          <formulsFraction :need-bottom-line="false">
            <div class="alternate-text">=</div>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column">
          <div class="formul-text d-flex"><span class="alternate-text mr-1">1,0 ×</span> <span
              class="d-flex flex-row align-end">No<span class="little-text " style="line-height:12px;">3</span></span>
          </div>
          <div class="formul-text d-flex"><span class="alternate-text mr-1">1,0 ×</span> <span
              class="d-flex flex-row align-end">КПo<span class="little-text " style="line-height:12px;">3</span></span>
          </div>
          <formulsFraction :need-bottom-line="true">
            <template>
              <span class="alternate-text mr-1">1,0 ×</span>
              <span class="d-flex flex-row align-end">ППo<span class="little-text "
                                                               style="line-height:12px;">3</span></span>
            </template>
            <template #bottom>очная <br>
              форма
            </template>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column mx-1">
          <div class="alternate-text">+</div>
          <div class="alternate-text">+</div>
          <formulsFraction :need-bottom-line="false">
            <div class="alternate-text">+</div>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column">
          <div class="formul-text d-flex"><span class="alternate-text mr-1">   0,25 ×</span> <span
              class="d-flex flex-row align-end">Nv<span class="little-text " style="line-height:12px;">3</span></span>
          </div>
          <div class="formul-text d-flex"><span class="alternate-text mr-1">   0,25 ×</span> <span
              class="d-flex flex-row align-end">КПv<span class="little-text " style="line-height:12px;">3</span></span>
          </div>
          <formulsFraction :need-bottom-line="true">
            <template><span class="alternate-text mr-1">   0,25 ×</span><span class="d-flex flex-row align-end">ППv<span
                class="little-text " style="line-height:12px;">3</span></span></template>
            <template #bottom>очно-заочная <br>
              форма
            </template>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column mx-1">
          <div class="alternate-text">+</div>
          <div class="alternate-text">+</div>
          <formulsFraction :need-bottom-line="false">
            <div class="alternate-text">+</div>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column">
          <div class="formul-text d-flex"><span class="alternate-text mr-1">   0,1 ×</span> <span
              class="d-flex flex-row align-end">Nz<span class="little-text " style="line-height:12px;">3</span></span>
          </div>
          <div class="formul-text d-flex"><span class="alternate-text mr-1">   0,1 ×</span> <span
              class="d-flex flex-row align-end">КПz<span class="little-text " style="line-height:12px;">3</span></span>
          </div>
          <formulsFraction :need-bottom-line="true">
            <template><span class="alternate-text mr-1">   0,1 ×</span><span class="d-flex flex-row align-end">ППz<span
                class="little-text " style="line-height:12px;">3</span></span></template>
            <template #bottom>заочная <br>
              форма
            </template>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column mx-1">
          <div class="alternate-text">=</div>
          <div class="alternate-text">=</div>
          <formulsFraction :need-bottom-line="false">
            <div class="alternate-text">=</div>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column">
          <div class="formul-text"><span class="alternate-text ">1,0 ×</span>
            {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nodao22, 0, 'integer', true, 0) }}
          </div>
          <div class="formul-text"><span class="alternate-text ">1,0 ×</span>
            {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nvpko22, 0, 'integer', true, 0) }}
          </div>
          <formulsFraction :need-bottom-line="true">
            <template><span class="alternate-text mr-1">1,0 ×</span>{{
                $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nvppo22, 0, 'integer', true, 0)
              }}
            </template>
            <template #bottom>очная <br>
              форма
            </template>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column mx-1">
          <div class="alternate-text">+</div>
          <div class="alternate-text">+</div>
          <formulsFraction :need-bottom-line="false">
            <div class="alternate-text">+</div>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column">
          <div class="formul-text"><span class="alternate-text ">   0,25 ×</span>
            {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nodav22, 0, 'integer', true, 0) }}
          </div>
          <div class="formul-text"><span class="alternate-text ">   0,25 ×</span>
            {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nvpkv22, 0, 'integer', true, 0) }}
          </div>
          <formulsFraction :need-bottom-line="true">
            <template><span class="alternate-text mr-1">   0,25 ×</span>{{
                $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nvppv22, 0, 'integer', true, 0)
              }}
            </template>
            <template #bottom>очно-заочная <br>
              форма
            </template>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column mx-1">
          <div class="alternate-text">+</div>
          <div class="alternate-text">+</div>
          <formulsFraction :need-bottom-line="false">
            <div class="alternate-text">+</div>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column">
          <div class="formul-text"><span class="alternate-text ">   0,1 ×</span>
            {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nodaz22, 0, 'integer', true, 0) }}
          </div>
          <div class="formul-text"><span class="alternate-text ">   0,1 ×</span>
            {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nvpkz22, 0, 'integer', true, 0) }}
          </div>
          <formulsFraction :need-bottom-line="true">
            <template><span class="alternate-text mr-1">   0,1 ×</span>
              {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nvppz22, 0, 'integer', true, 0) }}
            </template>
            <template #bottom>заочная <br>
              форма
            </template>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column mx-1">
          <div class="alternate-text">=</div>
          <div class="alternate-text">=</div>
          <formulsFraction :need-bottom-line="false">
            <div class="alternate-text">=</div>
          </formulsFraction>
        </div>
        <div class="d-flex flex-column">
          <div class="formul-text text-center">
            {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nodap22, 1, 'float', true, 0) }}
          </div>
          <div class="formul-text text-center">
            {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nvpkp22, 1, 'float', true, 0) }}
          </div>
          <formulsFraction :need-bottom-line="true">
            <template>
              {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nvppp22, 1, 'float', true, 0) }}
            </template>
            <template #bottom>приведенный<br>контингент</template>
          </formulsFraction>
        </div>
      </div>
      <p class="d-flex flex-row"><span class="d-flex flex-row align-end">NP<span class="little-text "
                                                                                 style="line-height:12px;">3</span></span>
        - приведенный контингент обучающихся по программам бакалавриата, специалитета и магистратуры</p>
      <p class="d-flex flex-row"><span class="d-flex flex-row align-end">ПКП<span class="little-text "
                                                                                  style="line-height:12px;">3</span></span>
        - приведенный контингент обучившихся по программам повышения квалификации</p>
      <p class="d-flex flex-row mb-5"><span class="d-flex flex-row align-end">ППП<span class="little-text "
                                                                                       style="line-height:12px;">3</span></span>
        - приведенный контингент обучившихся по программам профессиональной переподготовки</p>
      <div class="d-flex flex-row align-center">
        <formulsFraction :need-bottom-line="true">
          <template>
            <div class="d-flex flex-row align-end">
              {{ item.title }}
              <div class="little-text ">0</div>
            </div>
          </template>
          <template #bottom>значение</template>
        </formulsFraction>
        <formulsFraction :need-bottom-line="false">
          <template>
            <span class="mt-8 alternate-text"> = </span>
          </template>
        </formulsFraction>
        <formulsFractionSimple>
          <template>
            <span class="alternate-text mx-1">0,25  × </span> <span class="d-flex flex-row align-end">ПКП<span
              class="little-text " style="line-height:12px;">1</span></span> <span class="alternate-text mx-1">+</span>
            <span class="d-flex flex-row align-end">
              ППП<span class="little-text" style="line-height:12px;">1</span>
            </span>
          </template>
          <template #bottom>
            <div class="formul-text d-flex align-start" style="  min-height: 49px"><span
                class="d-flex flex-row align-end">NP<span class="little-text " style="line-height:12px;">1</span></span>
              <span class="mx-1 d-flex alternate-text">+</span> <span class="d-flex flex-row align-end">NOA<span
                  class="little-text " style="line-height:12px;">1</span></span></div>
          </template>
        </formulsFractionSimple>
        <formulsFraction :need-bottom-line="false">
          <template>
            <span class="mt-8 alternate-text"> + </span>
          </template>
        </formulsFraction>
        <formulsFractionSimple>
          <template>
            <span class="alternate-text mx-1">0,25  × </span> <span class="d-flex flex-row align-end">ПКП<span
              class="little-text " style="line-height:12px;">2</span></span> <span class="alternate-text mx-1">+</span>
            <span class="d-flex flex-row align-end">
              ППП<span class="little-text" style="line-height:12px;">2</span>
            </span>
          </template>
          <template #bottom>
            <div class="formul-text d-flex align-start" style="  min-height: 49px"><span
                class="d-flex flex-row align-end">NP<span class="little-text " style="line-height:12px;">2</span></span>
              <span class="mx-1 d-flex alternate-text">+</span> <span class="d-flex flex-row align-end">NOA<span
                  class="little-text " style="line-height:12px;">2</span></span></div>
          </template>
        </formulsFractionSimple>
        <formulsFraction :need-bottom-line="false">
          <template>
            <span class="mt-8 alternate-text"> = </span>
          </template>
        </formulsFraction>
        <formulsFractionSimple>
          <template>
            <span class="alternate-text mx-1">0,25  × </span>
            {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nvgkp22, 1, 'float', true, 0) }} <span
              class="alternate-text mx-1">+</span>
            {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nvgpp22, 1, 'float', true, 0) }}
          </template>
          <template #bottom>
            <span class="formul-text" style="  min-height: 49px"> {{
                $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nodgp22, 1, 'float', true, 0)
              }} <span class="alternate-text mx-1">+</span> 0</span>
          </template>
        </formulsFractionSimple>
        <formulsFraction :need-bottom-line="false">
          <template>
            <span class="mt-8 alternate-text"> + </span>
          </template>
        </formulsFraction>
        <formulsFractionSimple>
          <template>
            <span class="alternate-text mx-1">0,25  × </span>
            {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nvpkp22, 1, 'float', true, 0) }} <span
              class="alternate-text mx-1">+</span>
            {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nvppp22, 1, 'float', true, 0) }}
          </template>
          <template #bottom>
            <span class="formul-text" style="  min-height: 49px"> {{
                $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nodap22, 1, 'float', true, 0)
              }} <span class="alternate-text mx-1">+</span> {{
                $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nodcs22, 1, 'float', true, 0)
              }}</span>
          </template>
        </formulsFractionSimple>
        <formulsFraction :need-bottom-line="false">
          <template>
            <span class="mt-8 alternate-text"> = </span>
          </template>
        </formulsFraction>
        <formulsFraction :need-bottom-line="false">
          <template>
            <span class="mt-8">{{
                $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data[item.dataFieldName + 'b022'], item.prd + 1, 'float')
              }}</span>
          </template>
        </formulsFraction>
      </div>
      <p class="mb-3">Если хотя бы для одного вида экономической деятельности сумма значений показателей NP и NOA равна
        нулю, а сумма значений показателей ПКП и ППП больше нуля, значение принимается равным 1.</p>
    </template>
    <block-g :item="item" :row-of-values="rowOfValues"/>
  </div>
</template>

<script>
import BlockG from "@/components/cards/indicatiors/details/blockG";
// import ZeroRows from "@/components/cards/indicatiors/details/zeroRows";
import formulsFraction from "@/components/cards/indicatiors/formulsFraction";
import formulsFractionSimple from "@/components/cards/indicatiors/formulsFractionSimple"
import doubleFragmentTable from "@/components/cards/indicatiors/cardsTables/doubleFragmentTable"

export default {
  name: "b23",
  components: {/*ZeroRows*/BlockG, formulsFraction, formulsFractionSimple, doubleFragmentTable},
  props: {
    item: {
      type: Object
    },
    rowOfValues: {
      type: Object,
      default: () => {
      }
    },
  },
  methods: {
    checkData(value) {
      return this.rowOfValues.data.tabB23dpo ? this.rowOfValues.data.tabB23dpo[value] : 0;
    },

  },
}
</script>

<style lang="sass" scoped>
</style>